// Access Key, Secret Key, Customer ID를 상수로 정의
const accessLicense =
  "01000000002c6d768d23625955e7067e1ed0f16f74c2b201b6f4b464fb50a14eb03a5c85a0";
const secretKey = "AQAAAAAsbXaNI2JZVecGfh7Q8W90X1GTArfuEKLFWVBtl2f+uw==";
const customerId = "4132867";

//CORS우회 프록시 서버
const proxyURL = "https://cors-anywhere.herokuapp.com/";

// 네이버 키워드 검색 API를 이용하여 주어진 키워드에 대한 검색 결과 반환
async function fetchKeyword(keywords) {
  // console.log("=== fetchKeyword 함수 시작 ===");
  // console.log("입력된 키워드:", keywords);

  // API 호출에 필요한 인자들을 정의
  const method = "GET";
  const api_url = "/keywordstool";
  const timestamp = Date.now().toString();

  // console.log("API 호출 정보:");
  // console.log("- method:", method);
  // console.log("- api_url:", api_url);
  // console.log("- timestamp:", timestamp);

  // HMAC-SHA256 암호화를 이용하여 서명(signature)을 생성
  const signature = await createSignature(
    secretKey,
    timestamp,
    method,
    api_url
  );

  // console.log("생성된 signature:", signature);
  // console.log("사용된 secretKey:", secretKey);
  // console.log("사용된 accessLicense:", accessLicense);
  // console.log("사용된 customerId:", customerId);

  // // 생성한 서명과 함께 API를 호출하여 검색 결과 반환
  // console.log("API 호출 시작...");

  // API 파라미터 구성 - 여러 버전으로 테스트
  let params;

  // 버전 1: 기본 파라미터만
  params = new URLSearchParams({
    hintKeywords: keywords,
    showDetail: 1,
  });

  // 버전 2: siteId 추가 (필요시)
  // params = new URLSearchParams({
  //   hintKeywords: keywords,
  //   showDetail: 1,
  //   siteId: "4132867", // customerId와 동일하게 설정
  // });

  // 버전 3: biztpId 추가 (필요시)
  // params = new URLSearchParams({
  //   hintKeywords: keywords,
  //   showDetail: 1,
  //   biztpId: 1,
  // });

  // 버전 4: 모든 파라미터 (필요시)
  // params = new URLSearchParams({
  //   hintKeywords: keywords,
  //   showDetail: 1,
  //   siteId: "4132867",
  //   biztpId: 1,
  //   event: 1,
  //   month: new Date().getMonth() + 1,
  // });

  const apiUrl = `${proxyURL}https://api.naver.com/keywordstool?${params.toString()}`;

  const response = await fetch(apiUrl, {
    headers: {
      "X-Timestamp": timestamp,
      "X-API-KEY": accessLicense,
      "X-API-SECRET": secretKey, // 서버 코드와 동일하게 추가
      "X-CUSTOMER": customerId,
      "X-Signature": signature,
    },
  });

  // 검색 결과를 출력하는 함수를 호출
  const data = await response.json();

  if (data.keywordList && Array.isArray(data.keywordList)) {
    displayResults(data);
  }
}

// HMAC-SHA256 암호화를 이용하여 서명(signature)을 생성
async function createSignature(secretKey, timestamp, method, api_url) {
  // TextEncoder를 이용하여 입력 데이터를 UTF-8 형식으로 인코딩
  const encoder = new TextEncoder();
  const stringToSign = `${timestamp}.${method}.${api_url}`;
  const data = encoder.encode(stringToSign);

  // 암호화에 사용할 키를 생성
  const key = await crypto.subtle.importKey(
    "raw",
    encoder.encode(secretKey),
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"]
  );

  // 생성한 키와 입력 데이터를 이용하여 서명을 생성
  const signatureArrayBuffer = await crypto.subtle.sign("HMAC", key, data);

  // 서명 결과를 base64로 인코딩
  const signature = btoa(
    String.fromCharCode(...new Uint8Array(signatureArrayBuffer))
  );

  return signature;
}

// 검색 결과 출력
function displayResults(data) {
  // 최대 검색 결과 개수를 20개로 설정
  let maxResults = 20;
  for (let i = 0; i < data.keywordList.length; i++) {
    const keyword = data.keywordList[i];
    console.log(
      `키워드: ${keyword.relKeyword}, PC 월간 검색수: ${keyword.monthlyPcQcCnt}, 모바일 월간 검색수: ${keyword.monthlyMobileQcCnt}`
    );
    if (maxResults < i) break;
  }
}
//키워드 "자바스크립트로" 조회
// fetchKeyword("자바스크립트");

// 함수 export
export { fetchKeyword };
